import { render, staticRenderFns } from "./SearchRelevanceChooser.vue?vue&type=template&id=e78bfa50&"
import script from "./SearchRelevanceChooser.vue?vue&type=script&lang=ts&"
export * from "./SearchRelevanceChooser.vue?vue&type=script&lang=ts&"
import style0 from "./SearchRelevanceChooser.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports